import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  Link,
  List,
  ListItem,
  Button,
  Card,
  CardContent,
  IconButton,
  Container,
} from "@mui/material";
import { motion } from "framer-motion";

import { Chat } from "@mui/icons-material";

import Transcribe from "../../assets/Transcribe.png";
import ChatIcon from "../../assets/Chat.png";
import Other from "../../assets/Other.png";

import FilterBar from "../../components/FilterBar/FilterBar";
import Carousel from "../../components/Carousel/Carousel";
import openscan from "../../assets/Images_Mdhhtools/openscan.png";
import Revo from "../../assets/Images_Mdhhtools/Revo3d.png";
import xl_10000 from "../../assets/Images_Mdhhtools/10000xl.png";
import xl_11000 from "../../assets/Images_Mdhhtools/11000xl.png";
import xl_12000 from "../../assets/Images_Mdhhtools/12000xl.png";
import xl_13000 from "../../assets/Images_Mdhhtools/13000xl.png";
import viisan from "../../assets/Images_Mdhhtools/viisan.png";
import nikon from "../../assets/Images_Mdhhtools/nikon.png";
import nagra from "../../assets/Images_Mdhhtools/nagra.png";
import technica from "../../assets/Images_Mdhhtools/technica.png";
import crosley from "../../assets/Images_Mdhhtools/crosley.png";
import califone from "../../assets/Images_Mdhhtools/califone1.png";
import jvc from "../../assets/Images_Mdhhtools/jvc.png";
import rti from "../../assets/Images_Mdhhtools/rti.png";
import rs from "../../assets/Images_Mdhhtools/rs.png";
import tascam from "../../assets/Images_Mdhhtools/tascam.png";
import sony from "../../assets/Images_Mdhhtools/sony.png";
import lite from "../../assets/Images_Mdhhtools/Lite.png";
import funai from "../../assets/Images_Mdhhtools/funai.png";
import toshiba from "../../assets/Images_Mdhhtools/Toshiba.png";
import umatic from "../../assets/Images_Mdhhtools/umatic.png";
import mini from "../../assets/Images_Mdhhtools/mini.png";
import asus from "../../assets/Images_Mdhhtools/asus.png";
import slim from "../../assets/Images_Mdhhtools/slim.png";
import prusa from "../../assets/Images_Mdhhtools/prusa.png";
import pi from "../../assets/Images_Mdhhtools/pi.png";
import ibm from "../../assets/Images_Mdhhtools/ibm.png";
import kodak from "../../assets/Images_Mdhhtools/kodak.png";
import floppy from "../../assets/Images_Mdhhtools/floppy.png";
import qgis from "../../assets/Images_Mdhhtools/qgis.png";
import prusa1 from "../../assets/Images_Mdhhtools/prusa.png";
import blender from "../../assets/Images_Mdhhtools/blender.png";
import floppy1 from "../../assets/Images_Mdhhtools/floppy1.png";
import transparency from "../../assets/Images_Mdhhtools/transparency.png";
import { useNavigate } from "react-router-dom";
import PdfTutorials from "../Tutorials/PdfTutorials";

const MdhhTools = () => {
  const [hoveredOtherResources, setHoveredOtherResources] = useState(false);

  useEffect(() => {
    document.title = "Hub Tools - MS Digital Hub";
  }, []);
  const toolsData = [
    {
      name: "OpenScan Mini",
      category: "Object scanning (2D and 3D)",
      image: openscan,
      description: "Photogrammetry, small items (approx. <4 inches tall)",
      units: 1,
      location: "Mississippi Digital Humanities Hub",
      accessType: "hub",
    },
    {
      name: "Revopoint POP3 Plus Handheld 3D Scanner",
      category: "Object scanning (2D and 3D)",
      image: Revo,
      description: "Photogrammetry, medium-sized items",
      units: 1,
      location: "Mississippi Digital Humanities Hub",
      accessType: "hub",
    },
    {
      name: "Epson Expression 10000XL Flatbed Scanner",
      category: "Object scanning (2D and 3D)",
      image: xl_10000,
      description: '2D media up to 12" × 18"',
      units: 1,
      location: "DigiLab at Cook Library",
      accessType: "partner",
    },
    {
      name: "Epson Expression 11000XL Flatbed Scanner",
      category: "Object scanning (2D and 3D)",
      image: xl_11000,
      description: '2D media up to 12" × 18"',
      units: 4,
      location: "DigiLab at Cook Library",
      accessType: "partner",
    },
    {
      name: "Epson Expression 12000XL Flatbed Scanner",
      category: "Object scanning (2D and 3D)",
      image: xl_12000,
      description: '2D media up to 12" × 18"',
      units: 7,
      location: "DigiLab at Cook Library",
      accessType: "partner",
    },
    {
      name: "Epson Expression 13000XL Flatbed Scanner",
      category: "Object scanning (2D and 3D)",
      image: xl_13000,
      description: '2D media up to 12" × 18"',
      units: 3,
      location: "DigiLab at Cook Library",
      accessType: "partner",
    },
    {
      name: "Epson Scanner Transparency Adapter",
      category: "Object scanning (2D and 3D)",
      image: transparency,
      description:
        "Converts a compatible flatbed scanner for digitizing transparent media",
      units: 5,
      location: "DigiLab at Cook Library",
      accessType: "partner",
    },
    {
      name: "VIISAN S21 Large Format Scanner",
      category: "Object scanning (2D and 3D)",
      image: viisan,
      description: '2D media up to 12" × 18"',
      units: 1,
      location: "Mississippi Digital Humanities Hub",
      accessType: "partner",
    },
    {
      name: "Nikon Z 30 4K Mirrorless Camera with Lens and Creator Kit",
      category: "Object scanning (2D and 3D)",
      image: nikon,
      description: "3D media and large, layered, or delicate 2D materials",
      units: 1,
      location: "Mississippi Digital Humanities Hub",
      accessType: "partner",
    },

    {
      name: "NAGRA 4.2 Reel-to-Reel Recorder/Player",
      category: "Audio and Film",
      image: nagra,
      description: "Open audio reels and professional recordings",
      units: 1,
      location: "DigiLab at Cook Library",
      accessType: "partner",
    },
    {
      name: "Audio-Technica Professional Turntable",
      category: "Audio and Film",
      image: technica,
      description: "Vinyl records",
      units: 1,
      location: "DigiLab at Cook Library",
      accessType: "partner",
    },
    {
      name: "Crosley CR8005F-BK Cruiser Record Player",
      category: "Audio and Film",
      image: crosley,
      description: "Vinyl records",
      units: 1,
      location: "Mississippi Digital Humanities Hub",
      accessType: "partner",
    },
    {
      name: "Califone 1450K Record Player",
      category: "Audio and Film",
      image: califone,
      description: "Vinyl records",
      units: 1,
      location: "DigiLab at Cook Library",
      accessType: "partner",
    },
    {
      name: "JVC Super VHS Player",
      category: "Audio and Film",
      image: jvc,
      description: "Super VHS tapes",
      units: 1,
      location: "DigiLab at Cook Library",
      accessType: "partner",
    },
    {
      name: "RTI VT2100 VHS Tape Cleaner",
      category: "Audio and Film",
      image: rti,
      description: "Cleaning VHS tapes before digitization",
      units: 2,
      location: "DigiLab at Cook Library",
      accessType: "partner",
    },
    {
      name: "RS Concertmate 8 Radio / Tape Player",
      category: "Audio and Film",
      image: rs,
      description: "8-track tapes",
      units: 1,
      location: "DigiLab at Cook Library",
      accessType: "partner",
    },
    {
      name: "TASCAM Cassette Deck",
      category: "Audio and Film",
      image: tascam,
      description: "Cassette tapes",
      units: 1,
      location: "DigiLab at Cook Library",
      accessType: "partner",
    },
    {
      name: "SONY CD/DVD Player",
      category: "Audio and Film",
      image: sony,
      description: "CDs and DVDs",
      units: 1,
      location: "DigiLab at Cook Library",
      accessType: "partner",
    },
    {
      name: "LiteOn DVD/CD Writer",
      category: "Audio and Film",
      image: lite,
      description: "CDs and DVDs",
      units: 1,
      location: "Mississippi Digital Humanities Hub",
      accessType: "partner",
    },
    {
      name: "FUNAI VHS/DVD Player",
      category: "Audio and Film",
      image: funai,
      description: "DVD and VHS media",
      units: 1,
      location: "DigiLab at Cook Library",
      accessType: "partner",
    },
    {
      name: "TOSHIBA VHS/DVD Player",
      category: "Audio and Film",
      image: toshiba,
      description: "DVD and VHS media",
      units: 2,
      location: "DigiLab at Cook Library",
      accessType: "partner",
    },
    {
      name: "SONY U-matic Player",
      category: "Audio and Film",
      image: umatic,
      description: "U-matic and U-matic SP tapes",
      units: 2,
      location: "DigiLab at Cook Library",
      accessType: "partner",
    },
    {
      name: "Mini HD DVD Player",
      category: "Audio and Film",
      image: mini,
      description: "Mini HD discs",
      units: 1,
      location: "DigiLab at Cook Library",
      accessType: "partner",
    },
    {
      name: "ASUS Blu-Ray Player",
      category: "Audio and Film",
      image: asus,
      description: "Blu-Ray media",
      units: 1,
      location: "Mississippi Digital Humanities Hub",
      accessType: "partner",
    },
    {
      name: "LG Slim Portable Blu-Ray Writer",
      category: "Audio and Film",
      image: slim,
      description: "Blu-Ray media",
      units: 1,
      location: "Mississippi Digital Humanities Hub",
      accessType: "partner",
    },

    {
      name: "QGIS",
      category: "Software",
      image: qgis,
      description: "Mapping and visualizations",
      units: 1,
      location: "CDH Lab",
      accessType: "cdh-lab",
    },
    {
      name: "Prusa Slicer and G-code Viewer",
      category: "Software",
      image: prusa1,
      description: "Preparing and reviewing files for 3D printing",
      units: 1,
      location: "CDH Lab",
      accessType: "cdh-lab",
    },
    {
      name: "Blender",
      category: "Software",
      image: blender,
      description: "3D modeling",
      units: 1,
      location: "CDH Lab",
      accessType: "cdh-lab",
    },
    {
      name: "Revopoint",
      category: "Software",
      image: Revo,
      description: "Photogrammetry and 3D scanning",
      units: 1,
      location: "CDH Lab",
      accessType: "cdh-lab",
    },
  ];
  const categories = [
    "Object scanning (2D and 3D)",
    "Audio and Film",
    "Misc",
    "Software",
  ];
  const [selectedCategory, setSelectedCategory] = useState("All");
  const filteredTools =
    selectedCategory === "All"
      ? toolsData
      : toolsData.filter((tool) => tool.category === selectedCategory);
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        width: "auto",

        padding: "0px 20px",
        margin: "0px auto",
        padding: { xs: "20px", sm: "30px", md: "1px 80px" },
        border: "none",
        backgroundColor: "#ffffff",
        borderRadius: "8px",
      }}
    >
      <Typography
        variant="h4"
        sx={{
          marginBottom: "30px",
          paddingLeft: "10px",
          textAlign: "center",
        }}
      >
        Hub Tools
      </Typography>

      <Typography
        variant="body1"
        sx={{
          marginBottom: "30px",
          lineHeight: "1.8",
          textAlign: "justify",
        }}
      >
        The <strong>Mississippi Digital Humanities Hub</strong> is developing
        tools to assist researchers, teachers and librarians throughout
        Mississippi with their digitization and digital humanities projects. Our
        goal is to create a community that can share resources and ideas. These
        tools are currently under development, but will eventually include a
        transcription service, an asynchronous chat room where you seek help
        from others working on digital humanities projects, and additional
        resources. To sign up to access those resources (and to get
        notifications once those resources are launched), visit the "community
        initiatives" menu. In order to access the transcription portal, please
        sign up or log in <a href="/dh-hub">here</a>. Instructions for how to
        use the tools are <a href="/transcription-instructions">here</a>.
      </Typography>

      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: { xs: "1fr", sm: "1fr 1fr", md: "1fr 1fr 1fr" },
          gap: 3,
          marginBottom: "80px",

          alignItems: "center",
        }}
      >
        <Card
          sx={{
            p: 2,
            borderRadius: 2,
            boxShadow: 3,
            textAlign: "center",
            transition: "transform 0.3s ease-in-out",
            "&:hover": {
              transform: "scale(1.05)",
              bgcolor: "#fffbe7",
            },
          }}
          onClick={() => navigate(`/transcription`)}
        >
          <CardContent>
            <IconButton
              sx={{
                borderRadius: 0,
                padding: 0,
                background: "transparent",
                "&:hover": {
                  backgroundColor: "transparent",
                },
              }}
            >
              <Box
                component="img"
                src={Transcribe}
                alt="Custom Icon"
                sx={{
                  width: 80,
                  height: 80,
                  transition: "transform 0.3s ease-in-out",
                  "&:hover": {
                    transform: "scale(1.1)",
                  },
                }}
              />
            </IconButton>
            <Typography
              variant="h6"
              sx={{
                mt: 2,
                transition: "transform 0.3s ease-in-out",
                "&:hover": {
                  transform: "scale(1.1)",
                },
              }}
            >
              <br />
              Transcribing Manuscripts
            </Typography>
          </CardContent>
        </Card>
        <Card
          sx={{
            p: 2,
            borderRadius: 2,
            boxShadow: 3,
            textAlign: "center",
            transition: "transform 0.3s ease-in-out",
            "&:hover": {
              transform: "scale(1.05)",
              bgcolor: "#fffbe7",
            },
          }}
          onClick={() => navigate(`/Chat-Thread`)}
        >
          <CardContent>
            <IconButton
              sx={{
                borderRadius: 0,
                padding: 0,
                background: "transparent",
                "&:hover": {
                  backgroundColor: "transparent",
                },
              }}
            >
              <Box
                component="img"
                src={ChatIcon}
                alt="Custom Icon"
                sx={{
                  width: 80,
                  height: 80,
                  transition: "transform 0.3s ease-in-out",
                  "&:hover": {
                    transform: "scale(1.1)",
                  },
                }}
              />
            </IconButton>
            <Typography
              variant="h6"
              sx={{
                mt: 2,
                transition: "transform 0.3s ease-in-out",
                "&:hover": {
                  transform: "scale(1.1)",
                },
              }}
            >
              <br />
              Chat Thread
            </Typography>
          </CardContent>
        </Card>
        <Card
          sx={{
            position: "relative",
            p: 2,
            borderRadius: 2,
            boxShadow: 3,
            textAlign: "center",
            transition: "transform 0.3s ease-in-out",
            "&:hover": {
              transform: "scale(1.05)",
              bgcolor: "#fffbe7",
            },
          }}
          onMouseEnter={() => setHoveredOtherResources(true)}
          onMouseLeave={() => setHoveredOtherResources(false)}
        >
          {hoveredOtherResources && (
            <Box
              sx={{
                position: "absolute",
                top: "20px",
                left: 0,
                width: "100%",
                height: "100%",
                bgcolor: "",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontSize: "1.6rem",

                borderRadius: "5px",
              }}
            >
              Coming soon
            </Box>
          )}
          <CardContent
            sx={{
              filter: hoveredOtherResources ? "blur(4px)" : "none",
              transition: "filter 0.3s ease-in-out",
              position: "relative",
              zIndex: 1,
            }}
          >
            <IconButton
              sx={{
                borderRadius: 0,
                padding: 0,
                background: "transparent",
                "&:hover": {
                  backgroundColor: "transparent",
                },
              }}
            >
              <Box
                component="img"
                src={Other}
                alt="Custom Icon"
                sx={{
                  width: 80,
                  height: 80,
                  transition: "transform 0.3s ease-in-out",
                  "&:hover": {
                    transform: "scale(1.1)",
                  },
                }}
              />
            </IconButton>
            <Typography
              variant="h6"
              sx={{
                mt: 2,
                transition: "transform 0.3s ease-in-out",
                "&:hover": {
                  transform: "scale(1.1)",
                },
              }}
            >
              <br />
              Other Resources
            </Typography>
          </CardContent>
        </Card>
      </Box>

      <Typography
        variant="h4"
        sx={{
          marginBottom: "30px",
          textAlign: "center",
        }}
      >
        List of Digital Humanities Tools
      </Typography>
      <Box
        sx={{
          maxWidth: 900,
          mx: "auto",
          mb: 3,
          textAlign: "center",
        }}
      >
        <Typography
          sx={{
            color: "#555555",
            fontSize: "0.92rem",
            lineHeight: 1.7,
          }}
        >
          Equipment is available through the Hub or the DigiLab at Cook Library.
          Software is available in the Center for Digital Humanities Lab.
          Contact{" "}
          <Link
            href="mailto:dh@usm.edu"
            sx={{
              color: "#8a6211",
              fontWeight: 700,
            }}
          >
            dh@usm.edu
          </Link>{" "}
          for access or coordination.
        </Typography>
      </Box>
      <FilterBar
        categories={categories}
        selectedCategory={selectedCategory}
        setSelectedCategory={setSelectedCategory}
      />
      <Carousel tools={filteredTools} />
    </Box>
  );
};

export default MdhhTools;
